import { getMetadataFromUrl } from "../../data";
client import "./main.js";
static const basePath = import.meta.env.BASE_URL;
static declare global {
  interface Window {
    dataLayer: any[]; // Or a more specific type if you define a structure for your dataLayer pushes
  }
}
<const/{ pageImg, page }=getMetadataFromUrl($global.url.pathname)>

<!doctype html>
<html lang="en">
  <head>
    <title>${$global.meta.pageTitle || "evo-web"}</title>
    <meta
      name="description"
      content=`${$global.meta.pageDescription || "Evo Web contains the latest components built with a11y in mind"}`>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <if=page === "poc">
      <meta name="robots" content="noindex">
    </if>
    <meta property="og:title" content=`${$global.meta.pageTitle || "evo web"}`>
    <meta
      property="og:description"
      content=`${$global.meta.pageDescription || "Evo Web contains the latest components built with a11y in mind"}`>
    <meta property="og:type" content="website">
    <meta
      property="og:image"
      content=`${pageImg || ($global.meta as any).pageImg || ""}`>
    <meta
      name="twitter:image"
      content=`${pageImg || ($global.meta as any).pageImg || ""}`>
    <meta name="twitter:card" content="summary_large_image">
    <meta name="twitter:title" content=`${$global.meta.pageTitle || "evo web"}`>
    <meta
      name="twitter:description"
      content=`${$global.meta.pageDescription || "Evo Web contains the latest components built with a11y in mind"}`>
    <link
      rel="icon"
      type="image/png"
      href=`${basePath}favicon/favicon-96x96.png`
      sizes="96x96">
    <link rel="icon" type="image/svg+xml" href=`${basePath}favicon/favicon.svg`>
    <link rel="shortcut icon" href=`${basePath}favicon/favicon.ico`>
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href=`${basePath}favicon/apple-touch-icon.png`>
    <meta name="apple-mobile-web-app-title" content="Evo Web">
    <link rel="manifest" href=`${basePath}favicon/site.webmanifest`>
    // tracking
    <html-script
      async
      src="https://www.googletagmanager.com/gtag/js?id=G-9HQJ5CWCJZ"/>
    <script>
      (window.dataLayer ||= []).push(
        ["js", new Date()],
        ["config", "G-9HQJ5CWCJZ"],
      );
    </script>
  </head>
  <body class="evo-theme">
    <html-script>
      try {
        if (localStorage.getItem("evo-web-theme") === "evo-live") {
          document.body.classList.add("evo-theme-live");
        }
      } catch {}
    </html-script>
    <div class="skip-to-main-content">
      <a href="#main" class="clipped clipped--stealth">Skip to main content</a>
    </div>
    <master-icons/>
    <site-header/>
    <navrail page=page>
      <${input.content}/>
    </navrail>
    <site-footer/>
  </body>
</html>
